import banners from "./banners";
import boards from "./boards";
import center from "./center";
import companies from "./companies";
import company from "./company";
import expo from "./expo";
import forms from "./forms";
import interview from "./interview";
import lectures from "./lectures";
import me from "./me";
import message from "./message";
import person from "./person";
import popups from "./popups";
import recruitments from "./recruitments";
import setting from "./setting";
import terms from "./terms";
import users from "./users";
import * as shop from "./shop";

export default {
    banners,
    boards,
    center,
    companies,
    company,
    expo,
    forms,
    interview,
    lectures,
    me,
    message,
    person,
    popups,
    recruitments,
    setting,
    terms,
    users,
    ...shop,
};
